// Shop.js
import React, { useState, useEffect } from 'react';
import styles from './Shop.css'; // Adjust the path as needed

// Mock data for the items in the shop
const items = [
  {
    id: 1,
    name: 'Jewish Artworks',
    price: '$120',
    image: 'https://example.com/artwork.jpg',
    description: 'Beautiful Jewish artworks',
  },
  {
    id: 2,
    name: 'Candles',
    price: '$25',
    image: 'https://example.com/candles.jpg',
    description: 'Handmade candles for special occasions',
  },
  {
    id: 3,
    name: 'Books',
    price: '$45',
    image: 'https://example.com/books.jpg',
    description: 'Jewish books on history and culture',
  },
  {
    id: 4,
    name: 'Oil',
    price: '$15',
    image: 'https://example.com/oil.jpg',
    description: 'Olive oil for cooking and rituals',
  },
  // Add more items as needed...
];

function Shop() {
  return (
    <div className={styles.shop}>
      <h1 className={styles.shopTitle}>Jewish Shop</h1>
    
    UNDER CONSTRUCTION
    </div>
  );
}

export default Shop;
